var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.798 12.717H9.21v9.928c0 .196.159.355.355.355h4.088a.355.355 0 0 0 .355-.355v-9.881h2.773c.18 0 .332-.135.352-.314l.421-3.655a.355.355 0 0 0-.352-.396h-3.194V6.11c0-.692.372-1.042 1.106-1.042h2.088a.355.355 0 0 0 .355-.355V1.357a.355.355 0 0 0-.355-.354h-2.878A2.807 2.807 0 0 0 14.193 1c-.5 0-2.235.098-3.606 1.36C9.068 3.756 9.28 5.43 9.33 5.72V8.4H6.798a.355.355 0 0 0-.355.354v3.608c0 .196.16.355.355.355Z"
  })));
};
export default SvgFacebook;